import { ConfigProvider, DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en"; // ✅ บังคับเป็นอังกฤษ
import locale from "antd/es/date-picker/locale/en_US";

export default function CustomDatePicker({
  value,
  onChange,
  placeholder,
  className,
  maxDate,
}) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#00397d", // ✅ ใช้เป็นสี focus border ของ DatePicker
        },
      }}
    >
      <DatePicker
        className={`custom-datepicker ${className}`}
        locale={locale}
        value={value}
        onChange={(date) =>
          onChange ? onChange(date ? date.format("YYYY-MM-DD") : null) : null
        }
        placeholder={placeholder || "Select date"}
        disabledDate={(current) => current && current > dayjs(maxDate)}
      />
    </ConfigProvider>
  );
}
